import { jsx as _jsx } from "react/jsx-runtime";
import UITooltip from 'UIComponents/tooltip/UITooltip';

const FeaturesTableTitle = ({
  feature,
  showTooltip = true,
  highestTier
}) => {
  return /*#__PURE__*/_jsx("p", {
    style: showTooltip ? {
      cursor: 'help'
    } : {},
    children: /*#__PURE__*/_jsx(UITooltip, {
      placement: "right",
      disabled: !showTooltip,
      title: /*#__PURE__*/_jsx("span", {
        children: feature.descriptions[highestTier]
      }),
      children: /*#__PURE__*/_jsx("span", {
        children: feature.displayName
      })
    })
  });
};

export default FeaturesTableTitle;